import {AuthInterceptor} from './_interceptors/auth.interceptor';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HintComponent} from './hint/hint.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {LoadingComponent} from './loading/loading.component';
import {MatModule} from './mat.module';
import {MmComponent} from './mm/mm.component';
import {NgModule} from '@angular/core';
import {PwaInstallComponent} from './pwa-install/pwa-install.component';
import {RouterModule} from '@angular/router';
import {SmComponent} from './sm/sm.component';
import {SmIconComponent} from './sm/sm-icon.component';
import {SoComponent} from './so/so.component';
import {SoContentComponent} from './so/so-content.component';
import {WsComponent} from './ws/ws.component';

@NgModule({
  declarations: [
    HintComponent,
    LoadingComponent,
    MmComponent,
    PwaInstallComponent,
    SmComponent,
    SmIconComponent,
    SoComponent,
    SoContentComponent,
    WsComponent,
  ],
  exports: [
    FormsModule,
    HintComponent,
    HttpClientModule,
    LoadingComponent,
    MatModule,
    MmComponent,
    PwaInstallComponent,
    ReactiveFormsModule,
    SmComponent,
    SmIconComponent,
    SoComponent,
    SoContentComponent,
    WsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    MatModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
  ],
})
export class SharedModule {
}
